import { ForwardedRef, forwardRef } from 'react'

export interface ErrorMessage {
  message: string
}

interface Props<T> {
  autoComplete: string
  disabled?: boolean
  fieldErrors?: string | false
  className?: string
  labelClassName?: string
  inputClassName?: string
  label: string
  name: string
  placeholder?: string
  setValue: (val: T, name: string) => void
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  type: string
  value: string
  isCaptchaInput?: boolean
  onBlur?: () => void
  onFocus?: () => void
}

export const MobileAppInput = forwardRef(function Input<T extends string>(
  props: Props<T>,
  ref?: ForwardedRef<HTMLInputElement>,
): React.ReactElement {
  const {
    autoComplete,
    disabled,
    fieldErrors,
    className,
    labelClassName,
    inputClassName,
    label,
    placeholder,
    name,
    setValue,
    type,
    value,
    onClick,
    isCaptchaInput,
    onBlur,
    onFocus,
  } = props

  const isStringFieldError = typeof fieldErrors === 'string' && fieldErrors.length

  return (
    <div className={`${isCaptchaInput ? 'flex' : ''} ${className ?? ''}`}>
      <div className="w-full">
        <p className={`text-purple-mist text-xxs mb-1 ${labelClassName ?? ''}`}>{label}</p>
        <input
          autoComplete={autoComplete}
          className={`bg-white/10 w-full ${isStringFieldError ? '!border-red' : ''} ${inputClassName ?? ''}`}
          disabled={disabled}
          id={name}
          name={name}
          onBlur={onBlur}
          onChange={(e) => setValue(e.target.value as T, name)}
          onClick={onClick}
          onFocus={onFocus}
          placeholder={placeholder}
          ref={ref}
          type={type}
          value={value}
        />
        {isStringFieldError && <p className="text-red text-xxs mt-1">{fieldErrors}</p>}
      </div>
    </div>
  )
})
